import { Avatar, Box } from "@material-ui/core";
import { head, upperCase } from "lodash";
import React from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
// import { userProfile } from "../../utils";
import useStyles from "./styles";
// import NotInterestedIcon from "@material-ui/icons/NotInterested";
import defaultUserImage from "Assets/images/user-profile-icon.svg";
import { USERPROFILE } from "src/constants/routeConstants";

const UserProfileWidget = ({
  firstName,
  lastName,
  url,
  className,
  userId,
  base64,
  icon,
  isOnboarding = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  return firstName || lastName ? (
    <a
      href={userId ? `${USERPROFILE}/${userId}` : undefined}
      className={classes.userLink}
    >
      <Box
        // position="relative"
        className={`${userId ? "cursor-pointer" : ""}`}
        // onClick={() => (userId ? userProfile(userId, history) : null)}
      >
        {url || base64 || icon ? (
          // <Avatar className={`avatar-img ${className ? className : ""} ${classes.deactivatedUser}`}>
          <Avatar className={`avatar-img ${className ? className : ""}`}>
            {base64 ? (
              <img
                src={`data:image/png;base64,${base64}`}
                alt={t("addEditUser.user")}
                className="profile-pic"
              />
            ) : icon ? (
              icon
            ) : (
              <img
                src={`${process.env.REACT_APP_CLOUD_FRONT_URL}/${url}`}
                alt={t("addEditUser.user")}
                className="profile-pic"
              />
            )}
          </Avatar>
        ) : isOnboarding ? (
          <Avatar className={`avatar-img ${className ? className : ""}`}>
            <img src={defaultUserImage} alt={t("addEditUser.user")} />
          </Avatar>
        ) : (
          <Avatar
            // className={`avatar-img avatar-bg ${className ? className : ""} ${classes.deactivatedUser}`}>
            className={`avatar-img avatar-bg ${className ? className : ""}`}
          >
            {`${upperCase(head(firstName || ""))}${upperCase(
              head(lastName || "")
            )}`}
          </Avatar>
        )}
        {/* <NotInterestedIcon className={classes.deactivatedUserIcon} /> */}
      </Box>
    </a>
  ) : null;
};

export default UserProfileWidget;
